function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "w06wb",
  d: "M325.14 104.35l-.244 9.141s-15.218 11.278-44.336.899"
}), React.createElement("path", {
  id: "w06wc",
  d: "M280.56 87.626V80.62l13.175 17.504 9.566-16.858 8.656 16.48L325.14 80.62v12.052"
}), React.createElement("path", {
  id: "w06wd",
  d: "M280.56 102.338V80.62"
}), React.createElement("path", {
  id: "w06we",
  d: "M325.83 95.59c0 .452-.287.819-.64.819-.354 0-.64-.367-.64-.819 0-.453.286-.82.64-.82.353 0 .64.367.64.82"
}), React.createElement("path", {
  id: "w06wf",
  d: "M325.83 98.739c0 .453-.287.82-.64.82-.354 0-.64-.367-.64-.82 0-.452.286-.819.64-.819.353 0 .64.367.64.819"
}), React.createElement("path", {
  id: "w06wg",
  d: "M325.78 101.9c0 .453-.287.82-.64.82-.354 0-.64-.367-.64-.82 0-.453.286-.82.64-.82.353 0 .64.367.64.82"
}), React.createElement("path", {
  id: "w06wh",
  d: "M281.23 105.4c0 .453-.287.819-.64.819-.354 0-.64-.366-.64-.819 0-.453.286-.82.64-.82.353 0 .64.367.64.82"
}), React.createElement("path", {
  id: "w06wi",
  d: "M281.23 108.56c0 .452-.287.819-.64.819-.354 0-.64-.367-.64-.819 0-.453.286-.82.64-.82.353 0 .64.367.64.82"
}), React.createElement("path", {
  id: "w06wj",
  d: "M281.181 111.709c0 .453-.287.82-.64.82-.354 0-.641-.367-.641-.82 0-.453.287-.819.641-.819.353 0 .64.366.64.819"
}), React.createElement("path", {
  id: "w06wk",
  d: "M283.686 112.971c25.196 8.161 38.466-.787 38.466-.787l.386-24.235-11.121 14.772-8.077-15.771-9.17 15.881-11.02-14.954z"
}), React.createElement("path", {
  id: "w06wl",
  d: "M285.44 94.42l.516 16.467s1.045 1.771 12.232 2.841z"
}), React.createElement("path", {
  id: "w06wm",
  d: "M320.458 94.42l-.516 16.467s-1.045 1.771-12.232 2.841z"
}), React.createElement("path", {
  id: "w06wn",
  d: "M303.333 91.53l-6.733 11.32 6.309 4.002 6.383-3.69z"
}), React.createElement("path", {
  id: "w06wo",
  d: "M307.71 110.914s.062 2.036-1.825 1.528c0 0-1.149-.339-1.47-1.889 0 0-.372.106-.836.402 1.083.926 1.151 2.301 1.151 2.301-.015 1.174-.76 1.556-1.36 1.68v.005l-.04.004c-.39.072-.71.04-.71.04-1.585-.179-1.45-1.702-1.45-1.702s.063-1.406 1.181-2.333c-.478-.31-.865-.423-.865-.423-.322 1.55-1.47 1.89-1.47 1.89-1.888.506-1.826-1.53-1.826-1.53.07-1.829 2.576-1.407 2.576-1.407.1-.17-.1-.789-.1-.789-.68.563-1.424.27-1.424.27-.619-.253-.85-1.015-.673-1.66.104-.374.52-.673.87-.729.31-.05.624.058.897.221.274.163.537.385.743.642.22-.033.705-.25.996-.388a.787.787 0 0 1-.173-.188l.833.051 1.263-.077a.868.868 0 0 1-.208.224c.284.135.803.37 1.031.404.207-.256.47-.479.743-.643.273-.163.587-.27.897-.22.351.056.767.356.87.73.178.644-.054 1.406-.673 1.658 0 0-.743.294-1.424-.27 0 0-.2.621-.099.79 0 0 2.506-.42 2.575 1.408m-2.047-3.038a.387.387 0 0 0-.069.15.095.095 0 0 0 .001.041c.008.032.053.052.082.06a1.606 1.606 0 0 0 .622.074.438.438 0 0 0 .08-.015.377.377 0 0 0 .085-.03.277.277 0 0 0 .114-.1l.005-.009a.131.131 0 0 0 .013-.029.33.33 0 0 0 .03-.103.445.445 0 0 0-.149-.399l-.01-.007a.398.398 0 0 0-.151-.081l-.03-.006c-.013 0-.025-.002-.037-.003l-.036.002a.166.166 0 0 0-.032.003l-.032.008a.594.594 0 0 0-.039.013c-.252.1-.447.431-.447.431m-5.379.2s.085-.034-.043-.227c0 0-.26-.443-.566-.456h-.019a.271.271 0 0 0-.073.01c-.02.005-.04.014-.06.022a.516.516 0 0 0-.074.048l-.03.024a.416.416 0 0 0-.062.07l-.018.028a.432.432 0 0 0-.065.217v.01a.39.39 0 0 0 .021.155.298.298 0 0 0 .131.146l.037.016a.39.39 0 0 0 .131.034c.1.013.206.004.306-.005a1.515 1.515 0 0 0 .328-.07c.01-.002.017-.006.025-.009.021-.008.031-.014.031-.014m.298 2.385c.01-.042.018-.085.024-.128.011-.08-.035-.16-.123-.165a3.915 3.915 0 0 0-.405.009c-.15.012-.3.034-.444.068a1.597 1.597 0 0 0-.439.168.792.792 0 0 0-.31.31l-.006.01s-.226.285.275.835a.741.741 0 0 0 .2.162.533.533 0 0 0 .493.01c.265-.128.405-.384.523-.644.056-.125.103-.253.14-.383.023-.086.051-.168.072-.252m3.208 2.17a2.959 2.959 0 0 0-.418-.727 3.43 3.43 0 0 0-.214-.252c-.065-.07-.117-.153-.223-.138-.09.013-.168.144-.226.21a3.567 3.567 0 0 0-.23.292 4.933 4.933 0 0 0-.21.302c-.258.395-.472 1.011-.175 1.44.127.183.375.353.604.373.395.036.938-.005 1.151-.398.157-.289.05-.816-.059-1.102m.587-2.976s-.079-.775.162-1.358c0 0-.869-.334-1.616-.717-.734.372-1.56.691-1.56.691.24.583.16 1.36.16 1.36.757.147 1.328.645 1.328.645l.114.103.085-.078s.57-.498 1.327-.646m2.31 1.913c.5-.55.273-.835.273-.835 0-.003-.003-.007-.004-.01a.786.786 0 0 0-.31-.31 1.597 1.597 0 0 0-.44-.168 2.973 2.973 0 0 0-.444-.068 3.93 3.93 0 0 0-.326-.01l-.08.001c-.087.004-.133.084-.122.165.006.043.015.086.025.128.02.084.048.166.072.252.036.13.083.258.14.383.117.26.257.516.522.644a.533.533 0 0 0 .494-.01.757.757 0 0 0 .2-.162"
}), React.createElement("path", {
  id: "w06wp",
  d: "M63.43 87.8h.775v12.793c.59-2.126 3.026-5.193 7.417-5.193 4.981 0 7.748 3.171 7.748 7.982v9.865h-.774v-9.796c0-4.357-2.399-7.355-7.048-7.355-4.096 0-7.343 3.311-7.343 7.495v9.656h-.775z"
}), React.createElement("path", {
  id: "w06wq",
  d: "M82.47 108.437v-.069c0-3.66 3.617-5.542 8.229-5.542 2.583 0 5.092.453 6.937 1.08v-1.464c0-4.218-2.657-6.205-6.974-6.205-2.288 0-4.206.593-6.125 1.464l-.296-.627c2.03-.941 4.06-1.534 6.458-1.534 2.546 0 4.539.628 5.904 1.917 1.144 1.081 1.808 2.789 1.808 4.95v10.842h-.775v-4.114c-.775 2.022-3.542 4.532-8.266 4.532-3.616 0-6.9-1.778-6.9-5.23m15.176-1.568v-2.23c-1.957-.698-4.099-1.116-6.905-1.116-4.173 0-7.459 1.604-7.459 4.81v.07c0 3.068 2.88 4.567 6.13 4.567 4.948 0 8.234-2.998 8.234-6.101"
}), React.createElement("path", {
  id: "w06wr",
  d: "M82.47 108.437v-.069c0-3.66 3.617-5.542 8.229-5.542 2.583 0 5.092.453 6.937 1.08v-1.464c0-4.218-2.657-6.205-6.974-6.205-2.288 0-4.206.593-6.125 1.464l-.296-.627c2.03-.941 4.06-1.534 6.458-1.534 2.546 0 4.539.628 5.904 1.917 1.144 1.081 1.808 2.789 1.808 4.95v10.842h-.775v-4.114c-.775 2.022-3.542 4.532-8.266 4.532-3.616 0-6.9-1.778-6.9-5.23zm15.176-1.568v-2.23c-1.957-.698-4.099-1.116-6.905-1.116-4.173 0-7.459 1.604-7.459 4.81v.07c0 3.068 2.88 4.567 6.13 4.567 4.948 0 8.234-2.998 8.234-6.101z"
}), React.createElement("path", {
  id: "w06ws",
  d: "M103.06 95.818h.775v4.462c.554-2.232 3.063-4.88 6.384-4.88 4.022 0 6.051 2.37 6.716 5.193.7-2.509 3.284-5.193 6.604-5.193 4.096 0 6.938 2.579 6.938 7.529v10.319h-.775v-10.249c0-4.532-2.546-6.903-6.199-6.903-3.174 0-6.347 2.998-6.347 6.972v10.18h-.775v-10.249c0-4.532-2.546-6.903-6.199-6.903-3.174 0-6.347 2.998-6.347 6.972v10.18h-.775z"
}), React.createElement("path", {
  id: "w06wa",
  d: "M63 119.408h262.83V80H63z"
}), React.createElement("path", {
  id: "w06wu",
  d: "M135.31 90.836h1.144V88.85h-1.144zm.184 22.415h.775v-17.43h-.775z"
}), React.createElement("path", {
  id: "w06wv",
  d: "M141.73 113.247h.775V87.8h-.775z"
}), React.createElement("path", {
  id: "w06ww",
  d: "M148.735 108.789V96.483h-2.915v-.662h2.915V89.79h.775v6.031h6.827v.662h-6.827v12.236c0 2.614 1.329 4.148 3.948 4.148.923 0 1.919-.209 2.805-.628v.768a7.062 7.062 0 0 1-2.805.557c-3.062 0-4.723-1.743-4.723-4.775"
}), React.createElement("path", {
  id: "w06wx",
  d: "M148.735 108.789V96.483h-2.915v-.662h2.915V89.79h.775v6.031h6.827v.662h-6.827v12.236c0 2.614 1.329 4.148 3.948 4.148.923 0 1.919-.209 2.805-.628v.768a7.062 7.062 0 0 1-2.805.557c-3.062 0-4.723-1.743-4.723-4.775z"
}), React.createElement("path", {
  id: "w06wy",
  d: "M157.78 104.602v-.07c0-4.88 3.8-9.132 9.594-9.132 5.756 0 9.594 4.183 9.594 9.063v.069c0 4.881-3.801 9.134-9.594 9.134-5.757 0-9.594-4.184-9.594-9.064m18.386-.035v-.069c0-4.567-3.655-8.402-8.824-8.402-5.206 0-8.75 3.835-8.75 8.402v.069c0 4.566 3.655 8.401 8.824 8.401 5.206 0 8.75-3.835 8.75-8.401"
}), React.createElement("path", {
  id: "w06wz",
  d: "M157.78 104.602v-.07c0-4.88 3.8-9.132 9.594-9.132 5.756 0 9.594 4.183 9.594 9.063v.069c0 4.881-3.801 9.134-9.594 9.134-5.757 0-9.594-4.184-9.594-9.064zm18.386-.035v-.069c0-4.567-3.655-8.402-8.824-8.402-5.206 0-8.75 3.835-8.75 8.402v.069c0 4.566 3.655 8.401 8.824 8.401 5.206 0 8.75-3.835 8.75-8.401z"
}), React.createElement("path", {
  id: "w06wA",
  d: "M180.66 95.818h.775v4.775c.59-2.126 3.026-5.193 7.417-5.193 4.981 0 7.748 3.172 7.748 7.982v9.866h-.774v-9.796c0-4.358-2.399-7.356-7.048-7.356-4.096 0-7.343 3.312-7.343 7.495v9.657h-.775z"
}), React.createElement("path", {
  id: "w06wB",
  d: "M209.73 87.8h.775v19.347l12.804-11.329h1.033l-8.782 7.704 9.373 9.725h-.959l-8.893-9.273-4.576 4.01v5.263h-.775z"
}), React.createElement("path", {
  id: "w06wC",
  d: "M227.96 90.836h1.144V88.85h-1.144zm.184 22.415h.775v-17.43h-.775z"
}), React.createElement("path", {
  id: "w06wD",
  d: "M234.16 95.818h.775v4.775c.59-2.126 3.026-5.193 7.416-5.193 4.982 0 7.749 3.172 7.749 7.982v9.866h-.774v-9.796c0-4.358-2.399-7.356-7.048-7.356-4.096 0-7.343 3.312-7.343 7.495v9.657h-.775z"
}), React.createElement("path", {
  id: "w06wE",
  d: "M254.379 116.245l.48-.592c2.361 1.707 4.944 2.579 7.896 2.579 4.908 0 8.192-2.65 8.192-7.774v-3.555c-1.365 2.963-4.538 5.054-8.302 5.054-5.019 0-9.115-3.695-9.115-8.226v-.07c0-4.532 4.096-8.261 9.115-8.261 3.764 0 6.937 2.091 8.302 5.053v-4.635h.775v14.779c0 2.615-.849 4.672-2.362 6.101-1.549 1.464-3.874 2.231-6.605 2.231-3.099 0-5.83-.906-8.376-2.684m16.642-12.479v-.07c0-4.078-3.727-7.6-8.339-7.6-4.613 0-8.303 3.382-8.303 7.53v.07c0 4.148 3.69 7.564 8.303 7.564 4.612 0 8.339-3.416 8.339-7.494"
}), React.createElement("path", {
  id: "w06wF",
  d: "M254.379 116.245l.48-.592c2.361 1.707 4.944 2.579 7.896 2.579 4.908 0 8.192-2.65 8.192-7.774v-3.555c-1.365 2.963-4.538 5.054-8.302 5.054-5.019 0-9.115-3.695-9.115-8.226v-.07c0-4.532 4.096-8.261 9.115-8.261 3.764 0 6.937 2.091 8.302 5.053v-4.635h.775v14.779c0 2.615-.849 4.672-2.362 6.101-1.549 1.464-3.874 2.231-6.605 2.231-3.099 0-5.83-.906-8.376-2.684zm16.642-12.479v-.07c0-4.078-3.727-7.6-8.339-7.6-4.613 0-8.303 3.382-8.303 7.53v.07c0 4.148 3.69 7.564 8.303 7.564 4.612 0 8.339-3.416 8.339-7.494z"
}), React.createElement("clipPath", {
  id: "w06wt"
}, React.createElement("use", {
  xlinkHref: "#w06wa"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  transform: "translate(-62 -80)"
}, React.createElement("g", null, React.createElement("use", {
  fill: "#fff",
  fillOpacity: 0,
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 50,
  strokeWidth: 1.25,
  xlinkHref: "#w06wb"
})), React.createElement("g", null, React.createElement("use", {
  fill: "#fff",
  fillOpacity: 0,
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 50,
  strokeWidth: 1.25,
  xlinkHref: "#w06wc"
})), React.createElement("g", null, React.createElement("use", {
  fill: "#fff",
  fillOpacity: 0,
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 50,
  strokeWidth: 1.25,
  xlinkHref: "#w06wd"
})), React.createElement("g", null, React.createElement("use", {
  fill: "#fff",
  xlinkHref: "#w06we"
})), React.createElement("g", null, React.createElement("use", {
  fill: "#fff",
  xlinkHref: "#w06wf"
})), React.createElement("g", null, React.createElement("use", {
  fill: "#fff",
  xlinkHref: "#w06wg"
})), React.createElement("g", null, React.createElement("use", {
  fill: "#fff",
  xlinkHref: "#w06wh"
})), React.createElement("g", null, React.createElement("use", {
  fill: "#fff",
  xlinkHref: "#w06wi"
})), React.createElement("g", null, React.createElement("use", {
  fill: "#fff",
  xlinkHref: "#w06wj"
})), React.createElement("g", null, React.createElement("use", {
  fill: "#fff",
  fillOpacity: 0,
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 50,
  strokeWidth: 1.2,
  xlinkHref: "#w06wk"
})), React.createElement("g", null, React.createElement("use", {
  fill: "#fff",
  fillOpacity: 0,
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 50,
  strokeWidth: .98,
  xlinkHref: "#w06wl"
})), React.createElement("g", null, React.createElement("use", {
  fill: "#fff",
  fillOpacity: 0,
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 50,
  strokeWidth: .98,
  xlinkHref: "#w06wm"
})), React.createElement("g", null, React.createElement("use", {
  fill: "#fff",
  fillOpacity: 0,
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 50,
  strokeWidth: 1.2,
  xlinkHref: "#w06wn"
})), React.createElement("g", null, React.createElement("use", {
  fill: "#fff",
  xlinkHref: "#w06wo"
})), React.createElement("g", null, React.createElement("use", {
  fill: "#fff",
  xlinkHref: "#w06wp"
})), React.createElement("g", null, React.createElement("use", {
  fill: "#fff",
  fillOpacity: 0,
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 50,
  strokeWidth: .87,
  xlinkHref: "#w06wp"
})), React.createElement("g", null, React.createElement("use", {
  fill: "#fff",
  xlinkHref: "#w06wq"
})), React.createElement("g", null, React.createElement("use", {
  fill: "#fff",
  fillOpacity: 0,
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 50,
  strokeWidth: .87,
  xlinkHref: "#w06wr"
})), React.createElement("g", null, React.createElement("use", {
  fill: "#fff",
  xlinkHref: "#w06ws"
})), React.createElement("g", null, React.createElement("use", {
  fill: "#fff",
  fillOpacity: 0,
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 50,
  strokeWidth: .87,
  xlinkHref: "#w06ws"
})), React.createElement("g", null), React.createElement("g", {
  clipPath: "url(#w06wt)"
}, React.createElement("use", {
  fill: "#fff",
  xlinkHref: "#w06wu"
})), React.createElement("g", {
  clipPath: "url(#w06wt)"
}, React.createElement("use", {
  fill: "#fff",
  fillOpacity: 0,
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 50,
  strokeWidth: .87,
  xlinkHref: "#w06wu"
})), React.createElement("g", {
  clipPath: "url(#w06wt)"
}, React.createElement("use", {
  fill: "#fff",
  xlinkHref: "#w06wv"
})), React.createElement("g", {
  clipPath: "url(#w06wt)"
}, React.createElement("use", {
  fill: "#fff",
  fillOpacity: 0,
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 50,
  strokeWidth: .87,
  xlinkHref: "#w06wv"
})), React.createElement("g", {
  clipPath: "url(#w06wt)"
}, React.createElement("use", {
  fill: "#fff",
  xlinkHref: "#w06ww"
})), React.createElement("g", {
  clipPath: "url(#w06wt)"
}, React.createElement("use", {
  fill: "#fff",
  fillOpacity: 0,
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 50,
  strokeWidth: .87,
  xlinkHref: "#w06wx"
})), React.createElement("g", {
  clipPath: "url(#w06wt)"
}, React.createElement("use", {
  fill: "#fff",
  xlinkHref: "#w06wy"
})), React.createElement("g", {
  clipPath: "url(#w06wt)"
}, React.createElement("use", {
  fill: "#fff",
  fillOpacity: 0,
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 50,
  strokeWidth: .87,
  xlinkHref: "#w06wz"
})), React.createElement("g", {
  clipPath: "url(#w06wt)"
}, React.createElement("use", {
  fill: "#fff",
  xlinkHref: "#w06wA"
})), React.createElement("g", {
  clipPath: "url(#w06wt)"
}, React.createElement("use", {
  fill: "#fff",
  fillOpacity: 0,
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 50,
  strokeWidth: .87,
  xlinkHref: "#w06wA"
})), React.createElement("g", {
  clipPath: "url(#w06wt)"
}, React.createElement("use", {
  fill: "#fff",
  xlinkHref: "#w06wB"
})), React.createElement("g", {
  clipPath: "url(#w06wt)"
}, React.createElement("use", {
  fill: "#fff",
  fillOpacity: 0,
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 50,
  strokeWidth: .87,
  xlinkHref: "#w06wB"
})), React.createElement("g", {
  clipPath: "url(#w06wt)"
}, React.createElement("use", {
  fill: "#fff",
  xlinkHref: "#w06wC"
})), React.createElement("g", {
  clipPath: "url(#w06wt)"
}, React.createElement("use", {
  fill: "#fff",
  fillOpacity: 0,
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 50,
  strokeWidth: .87,
  xlinkHref: "#w06wC"
})), React.createElement("g", {
  clipPath: "url(#w06wt)"
}, React.createElement("use", {
  fill: "#fff",
  xlinkHref: "#w06wD"
})), React.createElement("g", {
  clipPath: "url(#w06wt)"
}, React.createElement("use", {
  fill: "#fff",
  fillOpacity: 0,
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 50,
  strokeWidth: .87,
  xlinkHref: "#w06wD"
})), React.createElement("g", {
  clipPath: "url(#w06wt)"
}, React.createElement("use", {
  fill: "#fff",
  xlinkHref: "#w06wE"
})), React.createElement("g", {
  clipPath: "url(#w06wt)"
}, React.createElement("use", {
  fill: "#fff",
  fillOpacity: 0,
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 50,
  strokeWidth: .87,
  xlinkHref: "#w06wF"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 264,
    height: 40,
    viewBox: "0 0 264 40"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/HKLogo.6942a9b2.svg";
export { SvgComponent as ReactComponent };